<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>

  import Header from "./components/Global/Header/index.vue"
  import Footer from "./components/Global/Footer/index.vue"

  export default{

    components: {
      
      Header,

      Footer
      
    },

    methods: {

      /* Add Color To Active Link On Loading Or Reloading By Fetch The Hash For Url */

      handle_active_link_color() {

        const hash = window.location.hash

        const elementNotFocus = document.querySelector

            (`.navbar-expand-lg .navbar-nav a[href='${hash}']`)
            
        elementNotFocus.style.color = "var(--main-color)"

        }

      /* ------------------------------------------------------------ */

    },

    mounted: function () {

      /* Handling The Padding Top For Body HTML Element */

      const headerElement = document.querySelector("header")

      const bodyElement = document.body
      
      bodyElement.setAttribute("style", `padding-top: ${headerElement.clientHeight}px`)

      /* ------------------------------------------------------------ */

      /* Call handle_active_link_color Function On Mounted App Component */

        this.handle_active_link_color()

      /* ------------------------------------------------------------ */

    },

    updated: function (){
      
      /*
        
          Call handle_active_link_color Function On Updated App Component
        
          ( On Redirect To Home Page By Click Redirect Button )
      
      */

      this.handle_active_link_color()

      /* ------------------------------------------------------------ */

    }

  }
  
</script>